import { Box, Button, Typography } from "@mui/material";
import { useGetStripeSetupIntentClientSecret } from "@queries/useGetStripeSetupIntentClientSecret";

export default function GetStripeSetupIntentClientSecretButton({ uuid }: { uuid: string }) {
  const {
    data,
    error,
    isLoading,
    isSuccess,
    isError,
    refetch, // 🔥 manual trigger
  } = useGetStripeSetupIntentClientSecret(uuid);

  const handleClick = () => {
    refetch();
  };

  return (
    <Box sx={{ p: "24px" }}>
      <Button onClick={handleClick} variant="contained">
        {isLoading ? "Getting..." : "Get Stripe Secret"}
      </Button>

      {isSuccess && (
        <Typography sx={{ mt: "16px", color: "green" }}>
          ✅ Success! data: {JSON.stringify(data)}
        </Typography>
      )}

      {isError && (
        <Typography sx={{ mt: "16px", color: "red" }}>
          ❌ Error: {(error as Error).message}
        </Typography>
      )}
    </Box>
  );
}
